/*jshint esversion: 6 */
jQuery(function($) {

  /******************************************/
    /********** VAR-----------/
  /******************************************/

  var LARGEUR_MAX_MOBILE = 800;
  var header = $("#masthead");
  var topMenuHeight = 80;
  var l_window_w = parseInt($(window).width());


  //$('.to_nicedropdown-js').niceSelect();


    //// VRAIMENT UTILE SITE EMPLOI //// 


  $('.to_nicedropdown-js').niceSelect();


  /******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/
 $(window).scroll(function () {
      action_on_scroll();
  });

  function action_on_scroll(){

     if ($(window).scrollTop() > 0){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
         header.removeClass("Masthead--sticky");
        $("body").removeClass('header--sticky');
      }

   }


  /* *****************  */
    /* SMOOTH SCROLL :  BACK TO TOP */
  /* *****************  */

    var linkboulangerie = $('.scrollToTop--js');
     linkboulangerie.click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 0 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });





  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


   
  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      var variable_here = 86;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight-variable_here;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();

  




    ////////////////
     /// ACORDEON //
     // .not( "#content_s_1" )
     $('.accordion-section-content').hide();
      //$('#content_s_1').parent().find('h2 a').addClass('active');

     //$('.accordion-section-content').hide();
      // ACCORDEON SECTION 
      function close_accordion_section() {
          $('.accordeon-page .accordion-section-title').removeClass('active');
          $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
      }

      $('.accordion-section-title').click(function(e) {
          // Grab current anchor value
          var currentAttrValue = $(this).attr('href');
        
           $('.accordeon-page .Accordeon-Item.active .Accordeon-Item-Content').not(currentAttrValue).slideUp(300);
           $('.accordeon-page .Accordeon-Item.active .Accordeon-Item-Content').not(currentAttrValue).parent().removeClass('active'); 

          if($(this).parent().parent().hasClass('active')) {
            
             // close_accordion_section();
              $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
              $(this).parent().parent().removeClass('active');

          }else {
            //  close_accordion_section();
   
              // Add active class to section title
              $(this).parent().parent().addClass('active');
              // Open up the hidden content panel
              $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
          }
   
          e.preventDefault();
      });
      // FIN ACCORDEON //
      ////////////////////


       $('.js-btn_scroll').click(function(e){

      var href = $(this).attr("href"),
          offsetTop = $(href).offset().top-topMenuHeight;
               $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
       
        e.preventDefault();
    });






});

  // tarteaucitron.init({
  //         "privacyUrl": "", /* Privacy policy url */
  //         "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
  //         "cookieName": "tartaucitron", /* Cookie name */
  //         "orientation": "bottom", /* Banner position (top - bottom) */
  //         "showAlertSmall": true, /* Show the small banner on bottom right */
  //         "cookieslist": false, /* Show the cookie list */
  //         "adblocker": false, /* Show a Warning if an adblocker is detected */
  //         "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
  //         "highPrivacy": true, /* Disable auto consent */
  //         "handleBrowserDNTRequest": false, /* If Do Not Track == 1, accept all */
  //         "removeCredit": false, /* Remove credit link */
  //         "moreInfoLink": false, /* Show more info link */
  //   });